import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {

  constructor(private meta: Meta, private titleService: Title) {
    this.meta.updateTag({ name: 'description', content: "Explore Edstate's Terms & Conditions: Learn about usage rules, privacy policies, and intellectual property rights. No refunds due to the program's nature." });
    titleService.setTitle("Terms & Conditions");
   }

  ngOnInit() {
  }

}
